module.exports = __webpack_public_path__ + "static/media/search.3d91a266.svg";